/**
 * Class strings BirthDetailsForm shares with BirthToolFormShell, the
 * placeholder that must render the same boxes. A plain module, so the shell
 * (shipped in the route's first load) never imports the deferred form itself.
 *
 * The no-birth-time toggle is a 44 px target (c-forms-09) that keeps its old
 * 16 px share of the layout: py-3.5 grows the hit area and -my-3.5 gives the
 * height back, so the calculator slots reserved around this form (nakshatra
 * finder, running dasha, yoga checks) do not grow. Its parent is a flex row,
 * which makes the button a block-level box whose margins do not leave an
 * inline strut behind.
 *
 * Its colour is the per-mode brand TEXT role: `text-intent-brand` paints the
 * cream-tuned CTA fill, about 3.55:1 on the dark card (below AA for 12 px).
 */
export const TIME_UNKNOWN_TOGGLE_CLASS =
  "-my-3.5 min-h-11 cursor-pointer py-3.5 text-left text-caption font-semibold text-[var(--intent-brand-text)] underline decoration-dotted disabled:cursor-not-allowed disabled:opacity-50";
